import { __assign, __rest } from "tslib";
import * as React from 'react';
import { ribbonSchemes } from '@mercell/tailwind';
import { twMerge } from 'tailwind-merge';
export var Ribbon = function (_a) {
    var children = _a.children, scheme = _a.scheme, className = _a.className, rest = __rest(_a, ["children", "scheme", "className"]);
    return (React.createElement("div", __assign({}, rest, { role: "status", className: twMerge('py-1 px-3 w-fit-content text-center rounded-full text-[0.875rem] leading-[1.25rem]', ribbonSchemes(scheme), className), style: { minWidth: 56 } }), children));
};
export default Ribbon;
